import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { hyperlinkOpenIcon } from '@progress/kendo-svg-icons';

@Component({
    selector: 'app-agents-configuration',
    templateUrl: './configuration.component.html',
    styleUrl: './configuration.component.scss',
    standalone: false
})
export class ConfigurationComponent {
  protected readonly hyperlinkIcon = hyperlinkOpenIcon;

  chatbotUrl = environment.URL_CHATBOT + '?test=1';

  openTab(url: string) {
    window.open(url, '_blank');
  }

}
